import { Component, Inject, OnInit } from '@angular/core';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { ValidationMessageService } from '../../../../../services/validation-message.service';
import { PaymentBankAccount } from '../../../../../models/entities/payment-bank-account';
import { BillPayService } from '../../../../../services/members/bill-pay.service';
import { LobBankAccount } from '../../../../../models/entities/lob-bank-account';
import { GrowlerService } from '../../../../../services/growler.service';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MicrodepositVerificationDialogInput
{
    paymentBankAccount?: PaymentBankAccount;
    lobBankAccount?: LobBankAccount;
}

export interface MicrodepositVerificationDialogResult
{
    success: boolean;
}

@Component({
    selector: 'lf-microdeposit-verification',
    templateUrl: './microdeposit-verification.component.html',
})
export class MicrodepositVerificationComponent implements OnInit
{
    public depositAmounts: number[] = [
        null,
        null,
    ];
    public requestInFlight: boolean = false;
    public isShowingInfo: boolean = true;
    public isShowingInputs: boolean = false;
    public isShowingWaitLater: boolean = false;

    constructor(
            private _dialogRef: MatDialogRef<MicrodepositVerificationComponent>,
            @Inject(MAT_DIALOG_DATA) public data: MicrodepositVerificationDialogInput,
            private _bankAccountsService: BankAccountsService,
            private _billPayService: BillPayService,
            private _validationMessageService: ValidationMessageService,
            private _growlerService: GrowlerService,
    ) {
    }

    ngOnInit() {
        this.depositAmounts = [
            null,
            null,
        ];
    }

    closeDialog() {
        this._dialogRef.close({success: false});
    }

    public verifyMicrodeposits() {
        if (this.data.paymentBankAccount) {
            const request = this.data.paymentBankAccount.ownerType.indexOf('User') !== -1
                    ? this._bankAccountsService.verifyUserBankAccountByMicrodeposit(this.data.paymentBankAccount.ownerId, this.data.paymentBankAccount.id, this.depositAmounts)
                    : this._bankAccountsService.verifyOrgBankAccountByMicrodeposit(this.data.paymentBankAccount.ownerId, this.data.paymentBankAccount.unifiedBankAccountId, this.depositAmounts);

            this.requestInFlight = true;
            request.subscribe(
                    (bankAccount: PaymentBankAccount) => {
                        // Save bank account event for consuming components.
                        this._bankAccountsService.paymentBankAccountChange(bankAccount);
                        this._dialogRef.close(<MicrodepositVerificationDialogResult>{success: true});

                        this.requestInFlight = false;
                        this._growlerService.success('Success', 'Bank account successfully verified.');
                    },
                    () => {
                        this.requestInFlight = false;
                        this._growlerService.error('Error', 'We were unable to verify your microdeposit amounts.');
                    },
            );
        }

        const jwt = LegFiJwtService.read();

        if (this.data.lobBankAccount) {
            const self = this;
            const body = {
                amount1: this.depositAmounts[0],
                amount2: this.depositAmounts[1],
            };
            this.requestInFlight = true;
            this._billPayService.verifyLobAccount(
                    jwt.memberId,
                    this.data.lobBankAccount.id,
                    body,
            ).subscribe(
                    () => {
                        self._billPayService.lobBankAccountChange();
                        this._dialogRef.close(<MicrodepositVerificationDialogResult>{success: true});
                        this.requestInFlight = false;
                        this._growlerService.success('Success', 'Bank account successfully verified.');
                    },
                    () => {
                        this.requestInFlight = false;
                        this._growlerService.error('Error', 'We were unable to verify your microdeposit amounts.');
                    },
            );
        }
    }
}
